export default __webpack_public_path__ + "static/media/starYeloow.9dac23ca.svg";